import { aboutData, images, companyInfo } from "../data/mock";
import { CheckCircle2 } from "lucide-react";

export const AboutSection = () => {
  return (
    <section id="about" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src={images.technician}
                alt="Certified HVAC engineer installing commercial air conditioning system"
                className="w-full h-[400px] lg:h-[480px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-900/30 to-transparent" />
            </div>
            {/* Floating stats card */}
            <div className="absolute -bottom-6 -right-4 sm:right-4 bg-white rounded-xl shadow-lg border border-slate-100 p-5 max-w-[220px]">
              <div className="grid grid-cols-2 gap-4">
                {aboutData.highlights.map((item, i) => (
                  <div key={i} className="text-center">
                    <p className="text-xl font-bold text-brand-600">{item.value}</p>
                    <p className="text-[11px] text-slate-500 mt-0.5 leading-tight">{item.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-brand-50 rounded-full px-4 py-1.5 mb-5">
              <div className="w-1.5 h-1.5 rounded-full bg-brand-500" />
              <span className="text-sm font-medium text-brand-700">{aboutData.title}</span>
            </div>

            <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-5 leading-tight">
              {aboutData.subtitle}
            </h2>

            <p className="text-slate-600 text-base leading-relaxed mb-6">
              {aboutData.description}
            </p>

            {aboutData.paragraphs.map((para, i) => (
              <div key={i} className="flex items-start gap-3 mb-4">
                <CheckCircle2 className="w-5 h-5 text-brand-500 mt-0.5 flex-shrink-0" />
                <p className="text-slate-600 text-sm leading-relaxed">{para}</p>
              </div>
            ))}

            {/* JMD Logo + Lifecycle */}
            <div className="mt-8 bg-slate-50 rounded-xl p-5 border border-slate-100">
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={companyInfo.logos.jmd}
                  alt="J.M.D. Airconditioning Co. India - Four decades of HVAC excellence"
                  className="h-12 w-auto object-contain"
                  loading="lazy"
                />
                <div>
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Backed By</p>
                  <p className="text-sm font-semibold text-slate-800">J.M.D. Airconditioning Co. (INDIA)</p>
                  <p className="text-[11px] text-slate-500">Obsessed with Quality Since 1982</p>
                </div>
              </div>
              <div className="border-t border-slate-200 pt-4">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">Complete Project Lifecycle</p>
                <div className="flex flex-wrap items-center gap-2">
                  {["Design", "Supply", "Installation", "Testing", "Commissioning", "Maintenance"].map((step, i) => (
                    <span key={step} className="flex items-center gap-2">
                      <span className="text-sm font-medium text-slate-700 bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm">
                        {step}
                      </span>
                      {i < 5 && <span className="text-accent-500 text-sm">→</span>}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
